var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:{ endless: _vm.endless }},_vm._l((_vm.items),function(item){return _c('li',{key:item},[_vm._v(_vm._s(item)),_c('nl-icon',{attrs:{"icon":"check-circle"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }